import { FetchAPI } from "@renedelangel/helpers";
import { urlServidor } from '../../helpers';

const CAMPOS = `
    seguimientoSiniestroID
    tipoSeguimientoID
    tipoSeguimiento
    empresaID
    empresa
    usuarioID
    usuario
    ejercicioID
    ejercicio
    semanaAltaID
    numSemanaAlta
    estadoID
    estado
    estadoColor
    estadoEsFinal
    descripcion
    numSiniestro
    bienDaniado
    folio
    montoReclamado
    fechaDanio
    fechaReclamacion
    fechaIngreso
    fechaSeguimiento
    diasSeguimiento
    numContacto
    responsableID
    origenID
    origenTipo
    responsable
    personalSeguimiento
    avance
    fechaAlta
`;

//PARA EL GET:

export const GET_SEGUIMIENTOSINIESTROS = `
query get($filtro: InputGetSeguimientoSiniestros){
    getSeguimientoSiniestros(filtro:$filtro){
        ${CAMPOS}
    }
}
`;

//PARA EL GET ALL:

export const GET_ALL_SEGUIMIENTOSINIESTROS = `
query filtroGetAll($filtro: InputGetSeguimientoSiniestros){
    getAllSeguimientoSiniestros(filtro: $filtro){
        ${CAMPOS}
    }
}
`;

//PARA LA TABLA:

export const TABLA_SEGUIMIENTOSINIESTROS = `
query filtro($filtro: InputFilterSeguimientoSiniestros){
    filterSeguimientoSiniestros(filtro: $filtro){
        listado{
            ${CAMPOS}
        }
        registros
        paginas
    }
}
`;

export const getSeguimientoSiniestros = async (filtro, token) => {
    try {
        let { getSeguimientoSiniestros } = await FetchAPI.graphql({
            token,
            variables: { filtro },
            url: urlServidor,
            query: GET_SEGUIMIENTOSINIESTROS
        });
        return getSeguimientoSiniestros;
    } catch ({ message }) { throw new Error(message); }
}

export const getAllSeguimientoSiniestros = async (variables, token) => {
    try {
        let { getAllSeguimientoSiniestros } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: GET_ALL_SEGUIMIENTOSINIESTROS
        });
        return getAllSeguimientoSiniestros;
    } catch ({ message }) { throw new Error(message); }
}

export const tablaSeguimientoSiniestros = async (variables, token) => {
    try {
        let { filterSeguimientoSiniestros } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: TABLA_SEGUIMIENTOSINIESTROS
        });
        return filterSeguimientoSiniestros;
    } catch ({ message }) { throw new Error(message); }
}

// Lupa del seguimiento de siniestros: reportes del Reporteador de Daños (finalizado = 1)
const TABLA_REPORTEADOR_DANIOS = `
query filterReporteDanios($filtro: InputFilterReporteDanios){
    filterReporteDanios(filtro: $filtro){
        listado{
            reporteDaniosID
            empresaID
            folioInterno
            estatus
            descripBreve
            fechaEvento
            lugarEvento
            danioOcasioA
        }
        registros
        paginas
    }
}
`;

export const tablaReporteadorDanios = async (variables, token) => {
    try {
        let { filterReporteDanios } = await FetchAPI.graphql({
            token,
            variables: { ...variables, filtro: { ...(variables.filtro || {}), finalizado: 1 } },
            url: urlServidor,
            query: TABLA_REPORTEADOR_DANIOS
        });
        return filterReporteDanios;
    } catch ({ message }) { throw new Error(message); }
}
